<template>
  <slot name="promo" />
  <div :class="['post', rootCls]">
    <div class="container-2024 grid-2024">
      <slot name="before-begin-article" />
      <aside class="aside-post" :class="asideLeftCls">
        <div class="aside-post__sticky">
          <slot name="aside-left" />
        </div>
      </aside>
      <article class="post-content" :class="postContentCls">
        <div class="post-content__section">
          <div
            id="article-text"
            class="post-content__body"
            itemprop="articleBody"
            itemscope
            itemtype="https://schema.org/Text"
          >
            <slot name="article" />
          </div>
          <div class="post-content__footer">
            <slot name="after-article" />
          </div>
        </div>
      </article>
      <aside v-if="withAsideRight" class="aside-post" :class="asideRightCls">
        <div class="aside-post__sticky">
          <slot name="aside-right" />
        </div>
      </aside>
      <slot name="after-end-article" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { SingleExpertiseProps } from './types';

  withDefaults(defineProps<SingleExpertiseProps>(), {
    rootCls: '-detail group-section',
    asideLeftCls: 'g-col-lg-2 g-col-full',
    asideRightCls: 'g-col-lg-2 g-start-lg-11 g-col-full',
    postContentCls: 'g-col-lg-6 g-start-lg-4 g-col-full',
    withAsideRight: true,
  });
</script>

<style lang="scss">
  @use './style.scss';
</style>

<i18n lang="json" src="./locale.json" />
